import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faExclamationCircle, faPlay, faPause, faVolumeMute, faVolumeUp, faCog, faCompress, faExpand, faImage } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _templateObject, _templateObject2, _templateObject3;
// Créez un composant Styled Component pour la div principale
var PlaybackSpeedContainer = /*#__PURE__*/styled.div(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  /* Vos styles CSS pour .PlaybackSpeed vont ici */\n"])));
// Créez un composant Styled Component pour les éléments li
var ListItem = /*#__PURE__*/styled.li(_templateObject2 || (_templateObject2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding:2px;\n  &.active {\n    background-color: #ccc !important;\n    color: black !important;\n    \n  }\n"])));
var SpeedValue = /*#__PURE__*/styled.small(_templateObject3 || (_templateObject3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  /* Vos styles CSS pour small.speed-value vont ici */\n"])));
var PlaybackSpeed = function PlaybackSpeed(_ref) {
  var close = _ref.close,
    defaultValue = _ref.defaultValue,
    select = _ref.select;
  var _useState = useState(defaultValue || 1),
    current = _useState[0],
    setCurrent = _useState[1];
  var values = [0.75, 1, 1.25, 1.50, 1.75, 2];
  var handleSet = function handleSet(value) {
    setCurrent(value);
    select(value);
  };
  return React.createElement(PlaybackSpeedContainer, null, React.createElement("ul", {
    className: "list-group resolution"
  }, React.createElement(ListItem, {
    className: "list-group-item d-flex jcsb gap-3"
  }, React.createElement(SpeedValue, {
    onClick: function onClick() {
      return close();
    }
  }, React.createElement(FontAwesomeIcon, {
    icon: faChevronLeft
  })), "Playback Speed"), values.map(function (value, index) {
    return React.createElement(ListItem, {
      key: index,
      onClick: function onClick() {
        return handleSet(value);
      },
      className: current === value ? "list-group-item d-flex jcc gap-3 active" : "list-group-item d-flex jcc gap-3"
    }, value === 1 ? "Normal" : value.toFixed(2));
  })));
};

var _templateObject$1;
var ListItem$1 = /*#__PURE__*/styled.li(_templateObject$1 || (_templateObject$1 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding:2px;\n  &.active {\n    background-color: #ccc !important;\n    color: black !important;\n    \n  }\n"])));
var Resolution = function Resolution(_ref) {
  var close = _ref.close,
    defaultValue = _ref.defaultValue,
    select = _ref.select;
  var _useState = useState(defaultValue || "SD"),
    current = _useState[0],
    setCurrent = _useState[1];
  var values = ["2K", "FULL HD", "HD", "SD"];
  var handleSet = function handleSet(value) {
    setCurrent(value);
    select(value);
  };
  return React.createElement("div", {
    className: "Resolution"
  }, React.createElement("ul", {
    className: "list-group resolution"
  }, React.createElement("li", {
    className: "list-group-item d-flex jcsb gap-3"
  }, React.createElement("small", {
    className: "speed-value",
    onClick: close
  }, React.createElement(FontAwesomeIcon, {
    icon: faChevronLeft
  })), "Resolutions"), values.map(function (value, index) {
    return React.createElement(ListItem$1, {
      key: index,
      onClick: function onClick() {
        return handleSet(value);
      },
      className: current === value ? "list-group-item d-flex jcc gap-3 active" : "list-group-item d-flex jcc gap-3"
    }, value);
  })));
};

var _templateObject$2;
// Créez un composant Styled Component pour la div principale
var PlayerSettingContainer = /*#__PURE__*/styled.div(_templateObject$2 || (_templateObject$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  /* Vos styles CSS pour .PlaybackSpeed vont ici */\n  /* Pour cibler le composant list-group de Bootstrap */\n  /* Styles pour un composant list-group de Bootstrap */\n\n  /* Styles de base pour le composant list-group */\n  .list-group {\n    display: flex;\n    flex-direction: column;\n    padding-left: 0;\n    margin-bottom: 0;\n  }\n  \n  /* Styles pour les \xE9l\xE9ments list-group */\n  .list-group-item {\n    position: relative;\n    display: block;\n    padding: 1px;\n    margin-bottom: -1px;\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.125);\n  }\n  \n  /* Style de survol pour les \xE9l\xE9ments list-group */\n  .list-group-item:hover {\n    z-index: 1;\n    border-color: rgba(0, 0, 0, 0.25);\n  }\n  \n  /* Style des \xE9l\xE9ments list-group actifs */\n  .list-group-item.active {\n    z-index: 2;\n    color: #fff;\n    background-color: #007bff;\n    border-color: #007bff;\n  }\n  \n  /* Style des \xE9l\xE9ments list-group d\xE9sactiv\xE9s */\n  .list-group-item.disabled {\n    pointer-events: none;\n    background-color: #f8f9fa;\n    color: #6c757d;\n  }\n  \n  /* Style des \xE9l\xE9ments list-group actifs et d\xE9sactiv\xE9s avec des liens */\n  .list-group-item.active,\n  .list-group-item.active:hover,\n  .list-group-item.active:focus {\n    z-index: 2;\n    color: #1d1d1d;\n    background-color: #efefef;\n    border-color: #007bff;\n  }\n  \n  .list-group-item.disabled,\n  .list-group-item.disabled:hover {\n    pointer-events: none;\n    background-color: #f8f9fa;\n    color: #6c757d;\n  }\n  \n  /* Style des \xE9l\xE9ments list-group en bordure arrondie */\n  .list-group-item:first-child {\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem;\n  }\n  \n  .list-group-item:last-child {\n    border-bottom-left-radius: 0.25rem;\n    border-bottom-right-radius: 0.25rem;\n  }\n  \n  /* Style des \xE9l\xE9ments list-group actifs en bordure arrondie */\n  .list-group-item.active:first-child {\n    border-top-left-radius: 0.25rem;\n  }\n  \n  .list-group-item.active:last-child {\n    border-bottom-right-radius: 0.25rem;\n  }\n  \n  /* Style des \xE9l\xE9ments list-group avec liens */\n  .list-group-item a {\n    color: inherit;\n    text-decoration: none;\n  }\n  .d-flex{\n    display: flex;\n  }\n  .jcsb{\n    justify-content: space-between;\n  }\n  \n\n"])));
var PlayerSetting = function PlayerSetting(_ref) {
  var close = _ref.close,
    playbackRate = _ref.playbackRate,
    defaultResolution = _ref.defaultResolution,
    handleSelect = _ref.handleSelect;
  var _useState = useState(false),
    playback = _useState[0],
    setPlayback = _useState[1];
  var _useState2 = useState(false),
    resolution = _useState2[0],
    setResolution = _useState2[1];
  useEffect(function () {
    var runLocalData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function runLocalData() {
        return _ref2.apply(this, arguments);
      };
    }();
    runLocalData();
  });
  return React.createElement(PlayerSettingContainer, {
    className: "setting",
    onMouseLeave: close
  }, playback ? React.createElement(PlaybackSpeed, {
    close: function close() {
      return setPlayback(false);
    },
    defaultValue: playbackRate,
    select: function select(value) {
      return handleSelect({
        playbackRate: value
      });
    }
  }) : null, resolution ? React.createElement(Resolution, {
    close: function close() {
      return setResolution(false);
    },
    defaultValue: defaultResolution,
    select: function select(value) {
      return handleSelect({
        resolution: value
      });
    }
  }) : null, !playback && !resolution ? React.createElement("ul", {
    className: "list-group player-setting"
  }, React.createElement("li", {
    className: "list-group-item d-flex jcsb gap-3",
    onClick: function onClick() {
      return setPlayback(!playback);
    }
  }, "Playback speed", React.createElement("small", {
    className: "speed-value"
  }, playbackRate === 1 ? "Normal" : playbackRate, React.createElement("i", {
    className: "fas fa-chevron-right"
  }))), React.createElement("li", {
    className: "list-group-item d-flex jcsb gap-3",
    onClick: function onClick() {
      return setResolution(!resolution);
    }
  }, "Resolution", React.createElement("small", {
    className: "speed-value"
  }, defaultResolution, React.createElement("i", {
    className: "fas fa-chevron-right"
  })))) : null);
};

// Fonction pour définir un cookie
var setCookie = function setCookie(name, value, days) {
  var expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = name + "=" + value + "; expires=" + expires + "; path=/";
};
// Fonction pour obtenir la valeur d'un cookie
var getCookie = function getCookie(name) {
  var cookies = document.cookie.split('; ');
  for (var _iterator = _createForOfIteratorHelperLoose(cookies), _step; !(_step = _iterator()).done;) {
    var cookie = _step.value;
    var _cookie$split = cookie.split('='),
      cookieName = _cookie$split[0],
      cookieValue = _cookie$split[1];
    if (cookieName === name) {
      return cookieValue;
    }
  }
  return '{}';
};

// Fonction pour sauvegarder une valeur dans les cookies
function setItem(key, value) {
  var old = getCookie("ouitubeplayer");
  var ouitubePlayer;
  if (old !== "undefined") {
    ouitubePlayer = JSON.parse(old);
  } else {
    ouitubePlayer = {};
  }
  ouitubePlayer[key] = value;
  setCookie("ouitubeplayer", JSON.stringify(ouitubePlayer), 366);
}
// Fonction pour récupérer une valeur depuis les cookies
function getItem(key) {
  var ouitubePlayerStr = getCookie("ouitubeplayer") || '{}';
  try {
    var ouitubePlayer = JSON.parse(ouitubePlayerStr);
    if (ouitubePlayer && ouitubePlayer[key]) {
      return ouitubePlayer[key];
    }
    return null;
  } catch (error) {
    console.error("Error parsing JSON from cookie:", error);
    return null;
  }
}

var _templateObject$3;
var LoaderContainer = /*#__PURE__*/styled.div(_templateObject$3 || (_templateObject$3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n\n    display: flex;\n    align-items: center;\n    justify-content:center;\n\n  .d-flex{\n    display: flex;\n  }\n    \n  .flex-column{\n    flex-direction: column;\n    \n  }\n\n  .align-items-center{\n    align-items: center;\n  }\n\n  .loader {\n    border: 6px solid #f3f3f3;\n    border-top: 6px solid #f00;\n    border-radius: 50%;\n    width: 50px;\n    height: 50px;\n    \n    animation: spin 2s linear infinite;\n  }\n\n  @keyframes spin {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n\n"])));
var Loader = function Loader(_ref) {
  var message = _ref.message;
  useEffect(function () {
    var runLocalData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function runLocalData() {
        return _ref2.apply(this, arguments);
      };
    }();
    runLocalData();
  });
  return React.createElement(LoaderContainer, null, !message && React.createElement("div", {
    className: "loader"
  }), message && React.createElement("div", {
    className: 'd-flex flex-column align-items-center'
  }, React.createElement("p", {
    style: {
      textAlign: "center",
      padding: 10 + "px"
    }
  }, message), React.createElement("div", {
    className: 'd-flex'
  }, React.createElement(FontAwesomeIcon, {
    icon: faExclamationCircle,
    size: '2xl'
  }))));
};

var _templateObject$4;
var StyledOuitubePlayer = /*#__PURE__*/styled.div(_templateObject$4 || (_templateObject$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  aspect-ratio: 16/9;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  background-color: #1d1d1d;\n  position: relative;\n  font-family: Arial, Helvetica, sans-serif;\n  color: white;\n  \n  .flex {\n    display: flex;\n  }\n  \n  .jcsb {\n    justify-content: space-between;\n  }\n  \n  .jcc {\n    justify-content: center;\n  }\n  \n  .flex-1 {\n    flex: 1;\n  }\n  \n  .gap-5 {\n    gap: 5px;\n  }\n  \n  .gap-10 {\n    gap: 10px;\n  }\n  \n  & .gap-15 {\n    gap: 15px;\n  }\n  \n  & video {\n    display: block;\n    max-width: 100%;\n    height: auto;\n  }\n  \n  & i.fas {\n    color: white;\n  }\n  \n  & h3 {\n    margin: 0;\n    padding: 10px 15px;\n  }\n  \n  .ouitube-player-error,\n  .ouitube-player-loading,\n  .ouitube-player-controls {\n    position: absolute;\n    display: none !important;\n    flex-direction: column;\n    justify-content: space-between;\n    bottom: 0;\n    width: 100%;\n    height: 100%;\n    box-shadow: inset 0 0 300px rgba(0, 0, 0, 0.5);\n  }\n  \n  &.pause .ouitube-player-controls {\n    display: flex !important;\n  }\n  \n  &:hover .ouitube-player-controls {\n    display: flex !important;\n  }\n  \n   .ouitube-player-control-header h3 {\n    color: white;\n  }\n  \n   .ouitube-player-control-header {\n    display: flex;\n    justify-content: space-between;\n  }\n  \n  .ouitube-player-control-footer {\n    cursor: pointer;\n  }\n  \n  .ouitube-player-control-footer .ouitube-progress {\n    display: flex;\n    justify-content: center;\n    margin: 10px 0;\n  }\n  \n  .ouitube-player-control-footer .progress-container {\n    width: 95%;\n    // background-color: #f4f4f4;\n    position: relative;\n  }\n  \n  .ouitube-player-control-footer .progress-bar {\n    height: 5px;\n    background-color: #f00;\n    text-align: center;\n    line-height: 30px;\n    color: white;\n  }\n  \n  .ouitube-control-options {\n    padding: 10px 15px;\n  }\n  \n  & .cog-icon ul {\n    position: absolute;\n    bottom: 70px;\n    right: 20px;\n  }\n  \n  &.fullScreen {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n  }\n  \n  & .cog-icon ul.resolution li {\n    text-align: center;\n  }\n  \n  & .cog-icon ul li {\n    background-color: #2f2f2f;\n    color: white;\n    font-size: 0.7rem;\n    border: 0px solid;\n  }\n  \n  & .circle {\n    width: 30px;\n    height: 30px;\n    background-color: #f00;\n    border-radius: 50%;\n    position: absolute;\n    right: 0;\n    top: 0;\n    display: none;\n  }\n  \n  & .volume-container {\n    width: 5px;\n    height: 100%;\n    background-color: #ccc;\n    margin: 2px;\n    position: relative;\n  }\n  \n  & #volume-progress {\n    width: 70px;\n    height: 20px;\n    background-color: #ccc;\n  }\n  \n  & #volume-progress .progress-bar {\n    width: 50%;\n    height: 100%;\n    border-left: 70px solid transparent;\n    border-bottom: 20px solid #00f;\n  }\n  \n  & #volume-control {\n    position: relative;\n    bottom: 4px;\n  }\n  \n  & input[type=\"range\"] {\n    width: 100px;\n    margin: 0;\n    appearance: none;\n    height: 5px;\n    background: rgb(255, 0, 0);\n    border-radius: 0px;\n  }\n  \n  & input[type=\"range\"]::-webkit-slider-thumb {\n    width: 15px;\n    height: 15px;\n    background: #fff;\n    border: 2px solid rgb(253, 253, 253);\n    border-radius: 50%;\n    appearance: none;\n    cursor: pointer;\n  }\n  \n  & input[type=\"range\"]::-moz-range-thumb {\n    width: 20px;\n    height: 20px;\n    background: #fff;\n    border: 2px solid #00f;\n    border-radius: 50%;\n    cursor: pointer;\n  }\n   .d-flex{\n    display: flex;\n   }\n   .gap-1{\n    gap:5px;\n   }\n   .gap-3{\n    gap:15px;\n   }\n   .custom-progress {\n    width: 100%; /* Largeur de la barre de progression */\n    height: 5px; /* Hauteur de la barre de progression */\n    appearance: none; /* Permet de contr\xF4ler l'apparence sans le style par d\xE9faut */\n    border: 1px solid #ccc;\n  \n    /* Styles sp\xE9cifiques \xE0 la barre de progression */\n    background-color: #f0f0f0; /* Couleur de fond de la barre de progression */\n    border-radius: 0px; /* Bord arrondi */\n  }\n  \n  /* Style de la partie remplie de la barre de progression */\n  .custom-progress::-webkit-progress-value {\n    background-color: #f00; /* Couleur de la partie remplie */\n    border-radius: 0px; /* Bord arrondi */\n  }\n  \n  /* Style de la partie non remplie de la barre de progression */\n  .custom-progress::-webkit-progress-bar {\n    background-color: #f0f0f0; /* Couleur de la partie non remplie */\n    border-radius: 5px; /* Bord arrondi */\n  }\n"])));
var OuitubePlayer = function OuitubePlayer(_ref) {
  var src = _ref.src,
    width = _ref.width,
    height = _ref.height,
    title = _ref.title,
    logo = _ref.logo,
    playing = _ref.playing,
    onReady = _ref.onReady,
    onStart = _ref.onStart,
    onDuration = _ref.onDuration,
    onPlay = _ref.onPlay,
    onPause = _ref.onPause,
    onProgress = _ref.onProgress,
    onEnded = _ref.onEnded,
    onError = _ref.onError;
  var videoRef = useRef(null);
  var lectorRef = useRef(null);
  var controlsRef = useRef(null);
  var loaderRef = useRef(null);
  var controlsTopRef = useRef(null);
  var controlsFooterRef = useRef(null);
  var _useState = useState(true),
    isPlay = _useState[0],
    setIsPlay = _useState[1];
  var _useState2 = useState(false),
    setting = _useState2[0],
    setSetting = _useState2[1];
  var _useState3 = useState(false),
    fullScreen = _useState3[0],
    setFullScreen = _useState3[1];
  var _useState4 = useState(!!getItem('muted') || false),
    muted = _useState4[0],
    setMuted = _useState4[1];
  var _useState5 = useState("00:00"),
    currentTime = _useState5[0],
    setCurrentTime = _useState5[1];
  var _useState6 = useState("00:00"),
    totalTime = _useState6[0],
    setTotalTime = _useState6[1];
  var _useState7 = useState(0),
    progressPercentage = _useState7[0],
    setProgressPercentage = _useState7[1];
  var _useState8 = useState(getItem('playbackRate') || 1),
    playbackRate = _useState8[0],
    setPlaybackRate = _useState8[1];
  var _useState9 = useState(getItem('volume') || 0.5),
    volume = _useState9[0],
    setVolume = _useState9[1];
  var _useState10 = useState(""),
    loaderMessage = _useState10[0],
    setLoaderMessage = _useState10[1];
  var _useState11 = useState(getItem('defaultResolution') || "SD"),
    defaultResolution = _useState11[0],
    setDefaultResolution = _useState11[1];
  var formatTime = function formatTime(timeInSeconds) {
    var hours = Math.floor(timeInSeconds / 3600);
    var minutes = Math.floor(timeInSeconds % 3600 / 60);
    var seconds = Math.floor(timeInSeconds % 60);
    var formattedHours = String(hours).padStart(2, '0');
    var formattedMinutes = String(minutes).padStart(2, '0');
    var formattedSeconds = String(seconds).padStart(2, '0');
    if (hours > 0) {
      return formattedHours + ":" + formattedMinutes + ":" + formattedSeconds;
    } else {
      return formattedMinutes + ":" + formattedSeconds;
    }
  };
  useEffect(function () {
    var videoElement = videoRef.current;
    var controls = controlsRef.current;
    var lector = lectorRef.current;
    var loader = loaderRef.current;
    setMuted(getItem('muted') || false);
    setPlaybackRate(getItem('playbackRate') || 1);
    setVolume(getItem('volume') || 0.5);
    setDefaultResolution(getItem('defaultResolution') || "SD");
    if (videoElement) {
      videoElement.style.display = "none";
    }
    if (loader) {
      loader.style.display = "flex";
    }
    if (videoElement && videoElement.src !== src) {
      console.log("new video");
      videoElement.currentTime = 0;
      videoElement.volume = volume;
      setProgressPercentage(0);
      setIsPlay(true);
      if (lector) {
        lector.classList.add('pause');
      }
      if (src) {
        if (defaultResolution) {
          videoElement.src = src; //+ '?resolution=' + defaultResolution;
        } else {
          videoElement.src = src;
        }
      }
      if (width) {
        videoElement.width = width;
      }
      if (height) {
        videoElement.height = height;
      }
      var handleLoadedMetadata = function handleLoadedMetadata() {
        var duration = videoElement.duration;
        videoElement.muted = muted;
        videoElement.playbackRate = playbackRate;
        videoElement.volume = volume;
        setTotalTime(formatTime(duration));
        onReady && onReady();
        onDuration && onDuration(duration);
        if (loader) {
          loader.style.display = "none";
        }
        if (controls) {
          controls.style.display = "flex";
          videoElement.style.display = "block";
        }
        videoElement == null || videoElement.removeEventListener('loadedmetadata', handleLoadedMetadata);
      };
      videoElement.addEventListener('timeupdate', function () {
        emitProgressEvent();
      });
      videoElement.addEventListener('ended', function () {
        handleEnded();
      });
      videoElement == null || videoElement.addEventListener('loadedmetadata', handleLoadedMetadata);
      videoElement == null || videoElement.addEventListener('error', function () {
        // Le chargement de la vidéo a échoué
        var msg = "The video failed to load, please reload the page. If this persists, please contact the author of the video.";
        setLoaderMessage(msg);
        onError && onError(msg);
      });
      if (playing) {
        togglePlay();
      }
    }
    return function () {
      // Cleanup if needed
      videoElement == null || videoElement.removeEventListener('timeupdate', function () {
        emitProgressEvent();
      });
      videoElement == null || videoElement.removeEventListener('ended', function () {
        handleEnded();
      });
      videoElement == null || videoElement.removeEventListener('loadedmetadata', function () {
        var duration = videoElement.duration;
        setTotalTime(formatTime(duration));
      });
    };
  }, [src, width, height, playing]);
  var emitProgressEvent = function emitProgressEvent() {
    var videoElement = videoRef.current;
    if (videoElement) {
      var _currentTime = videoElement.currentTime;
      var duration = videoElement.duration;
      if (!isNaN(_currentTime) && !isNaN(duration)) {
        var _progressPercentage = _currentTime / duration * 100;
        onProgress && onProgress({
          currentTime: _currentTime,
          duration: duration,
          progressPercentage: _progressPercentage
        });
        setCurrentTime(formatTime(_currentTime));
        setTotalTime(formatTime(duration));
        setProgressPercentage(_progressPercentage);
      }
    }
  };
  var seekTo = function seekTo(time) {
    var videoElement = videoRef.current;
    if (videoElement) {
      if (time >= 0 && time <= videoElement.duration) {
        videoElement.currentTime = time;
      }
    }
  };
  var handleEnded = function handleEnded() {
    var lectorElement = lectorRef.current;
    onEnded && onEnded();
    if (lectorElement) {
      lectorElement == null || lectorElement.classList.add('pause');
      onPause && onPause();
      setIsPlay(true);
    }
  };
  var togglePlay = function togglePlay() {
    var videoElement = videoRef.current;
    var lectorElement = lectorRef.current;
    if (videoElement) {
      if (videoElement.paused) {
        videoElement.play().then(function () {
          // La vidéo a commencé à jouer avec succès
          onPlay && onPlay();
          setIsPlay(false);
          onStart && onStart();
        })["catch"](function (error) {
          // Gérer les erreurs éventuelles lors du démarrage de la vidéo
          console.error("Erreur lors de la lecture de la vidéo :", error);
        });
      } else {
        videoElement.pause();
        setIsPlay(true);
        onPause && onPause();
      }
      lectorElement == null || lectorElement.classList.toggle('pause');
    }
  };
  var handleSetVolume = function handleSetVolume(e) {
    var videoElement = videoRef.current;
    if (videoElement) {
      videoElement.volume = e.target.value;
      setItem("volume", e.target.value);
    }
  };
  var handleSetProgress = function handleSetProgress(e) {
    var videoElement = videoRef.current;
    if (videoElement) {
      var rect = e.target.getBoundingClientRect();
      var offsetX = e.clientX - rect.left;
      var progressBarWidth = rect.width;
      var seekTime = offsetX / progressBarWidth * videoElement.duration;
      setItem("seekTime", seekTime);
      seekTo(seekTime);
    }
  };
  var handleMuted = function handleMuted() {
    var videoElement = videoRef.current;
    if (videoElement) {
      var newValue = !muted;
      setMuted(newValue);
      videoElement.muted = newValue;
      setItem("muted", newValue);
    }
  };
  var handleSelect = function handleSelect(e) {
    var videoElement = videoRef.current;
    if (videoElement) {
      if (e.playbackRate) {
        videoElement.playbackRate = e.playbackRate;
        setPlaybackRate(e.playbackRate);
        setItem("playbackRate", e.playbackRate);
      }
      if (e.resolution) {
        var mediaSource = videoElement.src;
        var resolutionParam = 'resolution=' + e.resolution;
        // Vérifier si le paramètre de résolution existe déjà dans l'URL
        if (mediaSource.includes('resolution=')) {
          // Si oui, le remplacer
          mediaSource = mediaSource.replace(/resolution=[^\&]+/, resolutionParam);
        } else {
          // Sinon, l'ajouter à l'URL
          mediaSource += (mediaSource.includes('?') ? '&' : '?') + resolutionParam;
        }
        videoElement.src = mediaSource;
        togglePlay();
        setDefaultResolution(e.resolution);
        setItem("defaultResolution", e.resolution);
      }
    }
  };
  var togglePictureInPicture = function togglePictureInPicture() {
    var videoElement = videoRef.current;
    if (videoElement) {
      if (document.pictureInPictureElement) {
        document.exitPictureInPicture();
      } else {
        videoElement.requestPictureInPicture();
      }
    }
  };
  var toggleFullScreen = function toggleFullScreen() {
    var lectorElement = lectorRef.current;
    if (lectorElement) {
      lectorElement.classList.toggle('fullScreen');
      if (lectorElement.classList.contains('fullScreen')) {
        // const fullscreenElement = document.documentElement; // Pour afficher la page entière
        // enterFullscreen(fullscreenElement);
        var now = new Date();
        var timestamp = now.getTime();
        lectorElement.style.zIndex = timestamp.toString();
        setFullScreen(true);
      } else {
        // exitFullscreen()
        setFullScreen(false);
      }
    }
  };
  return React.createElement(StyledOuitubePlayer, {
    ref: lectorRef,
    className: "ouitube-player pause"
  }, React.createElement("video", {
    ref: videoRef,
    controls: false,
    onContextMenu: function onContextMenu(e) {
      return e.preventDefault();
    }
  }), React.createElement("div", {
    ref: loaderRef,
    className: "ouitube-player-loader align-items-center justify-content-center"
  }, React.createElement(Loader, {
    message: loaderMessage
  })), React.createElement("div", {
    className: "ouitube-player-controls",
    ref: controlsRef
  }, React.createElement("div", {
    ref: controlsTopRef,
    className: "ouitube-player-control-header"
  }, title && React.createElement("h3", null, title), logo && React.createElement("img", {
    src: logo,
    width: 50,
    alt: "Logo"
  })), React.createElement("div", {
    ref: controlsFooterRef,
    className: "ouitube-player-control-footer"
  }, React.createElement("div", {
    className: "ouitube-progress"
  }, React.createElement("div", {
    className: "progress-container flex",
    onClick: handleSetProgress
  }, React.createElement("progress", {
    className: 'flex-1 custom-progress',
    max: "100",
    value: progressPercentage
  }))), React.createElement("div", {
    className: "ouitube-control-options flex jcsb"
  }, React.createElement("div", {
    className: "ouitube-control-option-left flex gap-10"
  }, React.createElement("div", {
    className: "ouitube-player-icon",
    onClick: togglePlay
  }, isPlay ? React.createElement(FontAwesomeIcon, {
    icon: faPlay
  }) : React.createElement(FontAwesomeIcon, {
    icon: faPause
  })), React.createElement("div", {
    className: "ouitube-player-time"
  }, React.createElement("span", null, currentTime), " / ", React.createElement("span", null, totalTime))), React.createElement("div", {
    className: "ouitube-control-option-right flex gap-15"
  }, React.createElement("div", {
    className: "volume-icon d-flex gap-1 align-items-center"
  }, muted ? React.createElement(FontAwesomeIcon, {
    icon: faVolumeMute,
    onClick: handleMuted
  }) : React.createElement(React.Fragment, null, React.createElement(FontAwesomeIcon, {
    icon: faVolumeUp,
    onClick: handleMuted
  }), React.createElement("div", null, React.createElement("input", {
    onChange: handleSetVolume,
    type: "range",
    id: "volume-control",
    min: 0,
    max: 1,
    step: "0.01",
    defaultValue: volume
  })))), React.createElement("div", {
    className: "cog-icon"
  }, setting ? React.createElement(PlayerSetting, {
    handleSelect: handleSelect,
    playbackRate: playbackRate,
    defaultResolution: defaultResolution,
    close: function close() {
      return setSetting(false);
    }
  }) : null, React.createElement(FontAwesomeIcon, {
    icon: faCog,
    onClick: function onClick() {
      return setSetting(!setting);
    }
  })), fullScreen ? React.createElement("div", {
    className: "enpand-icon"
  }, React.createElement(FontAwesomeIcon, {
    icon: faCompress,
    onClick: toggleFullScreen
  })) : React.createElement(React.Fragment, null, React.createElement("div", {
    className: "enpand-icon"
  }, React.createElement(FontAwesomeIcon, {
    icon: faExpand,
    onClick: toggleFullScreen
  })), React.createElement("div", {
    className: "image-icon"
  }, React.createElement(FontAwesomeIcon, {
    icon: faImage,
    onClick: togglePictureInPicture
  }))))))));
};

export { OuitubePlayer };
